import { Button } from '#atoms';
import { PATH } from '#const/path';
import { SERACH_QUERY } from '#pages/DashboardChartForm/hooks/useDashboardChartFormProcess';
import { DashboardChartModal } from '#pages/DashboardCustomer/DashboardChartModal';
import { useChat } from '#providers/Chat';
import { useDashboard } from '#providers/Dashboard';
import { ExerciseRecordStatus } from '#types/registeredLectures';
import { RegisteredCoachScheduleDetail } from '#types/schedule';
import sessionStorageManager from '#utils/sessionStorageManager';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { P, match } from 'ts-pattern';
import * as S from './styles';
import TagManager from 'react-gtm-module';

interface ButtonGroupProps {
  data: RegisteredCoachScheduleDetail | undefined;
}
export const ButtonGroup = ({ data }: ButtonGroupProps) => {
  const { openChat } = useChat();
  const navigate = useNavigate();

  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const { customerDetail } = useDashboard();

  const { lectureId: registeredLectureId } = useParams();

  const previousRegisteredLectureIndex =
    customerDetail?.registeredLectures?.findIndex(
      item => item.id === registeredLectureId
    );

  const previousRegisteredLectureId =
    customerDetail &&
    customerDetail.registeredLectures &&
    customerDetail?.registeredLectures[
      (previousRegisteredLectureIndex as number) + 1
    ]?.id;

  const handleChatButtonClick = (customerId: string | undefined) => {
    match(customerId).with(P.string, customerId => {
      const onSuccess = () => {
        navigate(PATH.CHAT_ROOM);
      };
      const onFail = () => '';

      openChat(customerId, onSuccess, onFail);
    });
  };

  const exerciseButtonText = match(data?.isGroup)
    .with(true, () => '기능 준비중')
    .otherwise(() =>
      match(data?.exerciseRecordStatus)
        .with(1, () => '등록')
        .with(2, () => '수정')
        .otherwise(() => '보기')
    );

  const { pathname } = useLocation();
  const { setBeforeChartPath } = sessionStorageManager();

  const handleRecordButtonClick = (
    exerciseRecordStatus: ExerciseRecordStatus | undefined
  ) => {
    match(exerciseRecordStatus)
      .with(1, () => {
        TagManager.dataLayer({
          dataLayer: {
            event: 'calender_exercisechart_fill_click',
            category: '일정관리',
            action: 'calender_exercisechart_fill_click',
            value: 2
          }
        });
        setModalOpen(true);
      })
      .with(2, () => {
        TagManager.dataLayer({
          dataLayer: {
            event: 'calender_exercisechart_edit_click',
            category: '일정관리',
            action: 'calender_exercisechart_edit_click',
            value: 2
          }
        });
        setBeforeChartPath(pathname);
        navigate(
          `${PATH.DASHBOARD_CHART_FORM_EDIT}?${SERACH_QUERY.REGISTERED_LECTURE_ID}=${registeredLectureId}`
        );
      })
      .with(3, () =>
        navigate(
          `${PATH.DASHBOARD_CHART}?${SERACH_QUERY.REGISTERED_LECTURE_ID}=${registeredLectureId}`
        )
      ).exhaustive;
  };

  return (
    <>
      <S.ButtonBox>
        <Button
          disabled={data?.status === 'CANCELLED' || data?.isGroup}
          onClick={() => handleRecordButtonClick(data?.exerciseRecordStatus)}
        >
          운동차트 {exerciseButtonText}
        </Button>
        <Button onClick={() => handleChatButtonClick(data?.personId)}>
          채팅
        </Button>
      </S.ButtonBox>

      {modalOpen && (
        <DashboardChartModal
          onClose={() => setModalOpen(false)}
          registeredLectureId={data?.id || ''}
          previousRegisteredLectureId={previousRegisteredLectureId}
        />
      )}
    </>
  );
};
